"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _text = require("./text.tokens");
var _jsxRuntime = require("react/jsx-runtime");
// In webfront the size prop is set as either a string or a number

var StyledHeading = _styledComponents.default.div.withConfig({
  displayName: "Heading__StyledHeading",
  componentId: "sc-we5wr1-0"
})(["display:inline-block;", " color:", ";cursor:inherit;white-space:", ";"], function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return theme.sys.font.heading[size];
}, function (_ref2) {
  var color = _ref2.color;
  return _text.tokens.color.headings[color];
}, function (_ref3) {
  var noWrap = _ref3.noWrap;
  return noWrap ? 'nowrap' : 'pre-wrap';
});
var Heading = function Heading(_ref4) {
  var children = _ref4.children,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? '1' : _ref4$size,
    _ref4$color = _ref4.color,
    color = _ref4$color === void 0 ? 'primary' : _ref4$color,
    noWrap = _ref4.noWrap,
    props = _objectWithoutProperties(_ref4, ["children", "size", "color", "noWrap"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledHeading, _objectSpread({
    size: size,
    color: color,
    noWrap: noWrap
  }, props, {
    children: children
  }));
};
var _default = exports.default = Heading;